import { brand } from "../../../brandVariables/getBandVariables";

export const BrandLogo = () => {
  return (
    <div className="brand-logo">
      <img src={brand.brandLogo} alt="" />
    </div>
  );
};
